import { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport'
import type { RpcInterceptor } from '@protobuf-ts/runtime-rpc/build/types/rpc-interceptor'
import {
  MethodInfo,
  RpcOptions,
  ServerStreamingCall,
  UnaryCall,
} from '@protobuf-ts/runtime-rpc'
import { shouldReroute } from 'shared/services/grpc/client-utils'
import settings from 'shared/common/settings'

export class DynamicGrpcWebTransport extends GrpcWebFetchTransport {
  private readonly localBaseUrl: string | undefined
  private readonly remoteBaseUrl: string
  private readonly localReroute: string | undefined

  constructor(interceptors: RpcInterceptor[]) {
    const remoteBaseUrl = settings.getValue('K2_GRPC_WEB_GATEWAY')
    const localBaseUrl =
      settings.getValue('LOCAL_K2_GRPC_WEB_GATEWAY') || 'http://localhost:9302'
    const localReroute = settings.getValue('LOCAL_K2_REROUTE')

    super({ baseUrl: remoteBaseUrl, interceptors: interceptors })
    if (localReroute) {
      this.localBaseUrl = localBaseUrl
    }
    this.remoteBaseUrl = remoteBaseUrl
    this.localReroute = localReroute
  }

  // override unary to use the correct transport
  override unary<I extends object, O extends object>(
    method: MethodInfo<I, O>,
    input: I,
    options: RpcOptions,
  ): UnaryCall<I, O> {
    return super.unary(method, input, {
      ...options,
      baseUrl: shouldReroute(method, this.localReroute)
        ? this.localBaseUrl
        : this.remoteBaseUrl,
    })
  }

  // override serverStreaming to use the correct transport
  override serverStreaming<I extends object, O extends object>(
    method: MethodInfo<I, O>,
    input: I,
    options: RpcOptions,
  ): ServerStreamingCall<I, O> {
    return super.serverStreaming(method, input, {
      ...options,
      baseUrl: shouldReroute(method, this.localReroute)
        ? this.localBaseUrl
        : this.remoteBaseUrl,
    })
  }
}
